// Icon names that are actually registered in assets/icons/icons.js. Anything
// outside this set renders as an empty box, so every nav surface (sidebar,
// spotlight) funnels its icon strings through normalizeNavIcon first and falls
// back to `cil-list`. Keep in sync with the icons imported in icons.js — add
// the import there BEFORE adding the name here.
export const ALLOWED_NAV_ICONS = new Set([
  'cil-amazon',
  'cil-arrow-right',
  'cil-ban',
  'cil-basket',
  'cil-bell',
  'cil-box',
  'cil-building',
  'cil-calculator',
  'cil-calendar',
  'cil-call-incoming',
  'cil-call-outgoing',
  'cil-cart',
  'cil-cash',
  'cil-chart-bar',
  'cil-chart-line',
  'cil-chart-pie',
  'cil-chart-up',
  'cil-check',
  'cil-check-circle',
  'cil-clock',
  'cil-cloud-download',
  'cil-cloud-upload',
  'cil-comment-square',
  'cil-copy',
  'cil-credit-card',
  'cil-cup',
  'cil-cursor',
  'cil-devices',
  'cil-dollar',
  'cil-drop',
  'cil-envelope-closed',
  'cil-envelope-open',
  'cil-euro',
  'cil-file',
  'cil-fingerprint',
  'cil-flag',
  'cil-flipkart',
  'cil-funnel',
  'cil-gift',
  'cil-globe-alt',
  'cil-grid',
  'cil-hand-coin',
  'cil-inventory',
  'cil-justify-center',
  'cil-laptop',
  'cil-layers',
  'cil-library',
  'cil-lightbulb',
  'cil-list',
  'cil-location-pin',
  'cil-lock-locked',
  'cil-magnifying-glass',
  'cil-money-back',
  'cil-moon',
  'cil-note',
  'cil-options',
  'cil-package',
  'cil-pencil',
  'cil-people',
  'cil-phone',
  'cil-phone-chart',
  'cil-puzzle',
  'cil-receipt',
  'cil-refund',
  'cil-report',
  'cil-route',
  'cil-scan',
  'cil-settings',
  'cil-share-arrow',
  'cil-shield-alt',
  'cil-speech',
  'cil-speedometer',
  'cil-spreadsheet',
  'cil-star',
  'cil-task',
  'cil-ticket',
  'cil-truck',
  'cil-user',
  'cil-user-chart',
  'cil-user-female',
  'cil-user-follow',
  'cil-wallet',
  'cil-x-circle',
])

/**
 * Accepts either camelCase (`cilChartPie`, as written in the sidebar configs)
 * or kebab-case (`cil-chart-pie`) and returns a registered kebab-case name.
 *
 * @param {string} icon
 * @returns {string}
 */
export function normalizeNavIcon(icon) {
  if (!icon || typeof icon !== 'string') {
    return 'cil-list'
  }

  const kebab = icon.startsWith('cil-')
    ? icon.toLowerCase()
    : icon.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()

  if (!ALLOWED_NAV_ICONS.has(kebab)) {
    return 'cil-list'
  }

  return kebab
}
